export enum DialogResult {
  Cancel,
  Ok,
}
